module.exports = __webpack_public_path__ + "static/media/noRecord.6ff07f93.svg";